import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_MONEY implements Validator {

	public static id = 'CTRL_MONEY';
	private message = 'error.ctr_MONEY';


	public LOG: LogService = new LogService(CTRL_MONEY);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_MONEY.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const firstWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
				const firstCtrl = form.controls[firstWithStepId];

				const reg = new RegExp('^[1-9][0-9]*(\\.[0-9]?[1-9])?$');

				if (!firstCtrl || !reg.test(firstCtrl.value)) {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				} else {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				}
			}
		}
	}
}
